import React, { Fragment } from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

const NotFound = ()=>{
    const navigate = useNavigate()
    return (
        <Fragment>
            <Navbar />
            <div className='container p-5 my-5' data-aos='fade-in'>
                <p className='fw-bold-0 fs-3 pt-md-5 pt-3'>
                    No Results Found
                </p>
                <p className='text-yrh fs-5'>
                    The page you requested could not be found. Try refining your search, or use the navigation above to locate the path.
                </p>
                <Button onClick={()=>navigate('/')} className='bg-yrh text-white fw-bold px-5 py-3 font-poppins'>
                    Take me Home
                </Button>
            </div>
            <Footer />
        </Fragment>
    )
}

export default NotFound